module.exports = __webpack_public_path__ + "static/trace-8e6d8b898ddb921afbcd64bcc36df65a.png";